function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAkouoMiniLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "401px",
    height: "400px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.941
    },
    fill: "#fefffe",
    d: "M 250.5,71.5 C 251.552,71.3505 252.552,71.5172 253.5,72C 261.651,78.907 269.984,85.5736 278.5,92C 269.261,105.241 258.594,117.241 246.5,128C 235.224,134.16 223.558,134.993 211.5,130.5C 210.882,124.953 211.882,119.619 214.5,114.5C 225.032,119.093 234.198,117.093 242,108.5C 242.617,107.551 242.451,106.718 241.5,106C 237.472,103.651 233.806,100.817 230.5,97.5C 237.574,89.0998 244.24,80.4331 250.5,71.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.972
    },
    fill: "#fefffe",
    d: "M 166.5,143.5 C 200.368,140.009 224.202,153.675 238,184.5C 242.505,171.65 247.005,158.817 251.5,146C 265.179,145.167 278.846,145.334 292.5,146.5C 280.34,175.815 268.673,205.315 257.5,235C 259.758,250.535 264.258,265.368 271,279.5C 277.478,287.363 285.645,289.696 295.5,286.5C 293.417,300.176 287.083,311.343 276.5,320C 261.182,324.89 250.015,320.057 243,305.5C 239.597,296.626 236.597,287.626 234,278.5C 212.186,321.158 179.019,333.658 134.5,316C 114.128,301.904 102.295,282.404 99,257.5C 94.9368,229.541 99.6035,203.208 113,178.5C 125.531,158.656 143.365,146.989 166.5,143.5 Z M 173.5,175.5 C 187.901,173.12 199.401,177.787 208,189.5C 216.437,202.468 221.937,216.635 224.5,232C 220.135,248.56 212.968,263.727 203,277.5C 186.183,295.254 168.85,295.921 151,279.5C 138.731,260.477 135.064,239.81 140,217.5C 142.38,203.903 148.547,192.403 158.5,183C 163.152,179.628 168.152,177.128 173.5,175.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAkouoMiniLogoWhite);
export default __webpack_public_path__ + "static/media/akouo-mini-logo-white.de73ef673125f2b69c581c75af9e69a3.svg";
export { ForwardRef as ReactComponent };